import { apiCall } from '../utils/api';

// Submit result after completing a game
// Reflex Tap needs more fields (score, averageReactionTime, etc.)

export async function submitArenaResult(payload) {
  const { gameType, completionTime, score, totalTaps, averageReactionTime, maxCombo } = payload || {};

  const res = await apiCall('/api/arena/submit', {
    method: 'POST',
    body: JSON.stringify({
      gameType,
      completionTime,
      score,
      totalTaps,
      averageReactionTime,
      maxCombo,
    }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to submit result');
  return data;
}



// Get today's leaderboard for a game (public, no auth needed)
// Returns { leaderboard: [...], total, seed }
export async function getArenaLeaderboard(gameType) {
  const res = await apiCall(`/api/arena/leaderboard?gameType=${gameType}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to fetch leaderboard');
  return data;
}

// Get current user's stats for a game
// Returns { currentStreak, bestStreak, bestRank, bestTime, totalCompleted }
export async function getArenaStats(gameType) {
  const res = await apiCall(`/api/arena/stats?gameType=${gameType}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to fetch stats');
  return data;
}

// Check if user already played today
// Returns { played: bool, result: { completionTime, rank } | null }
export async function getTodayStatus(gameType) {
  const res = await apiCall(`/api/arena/today-status?gameType=${gameType}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to fetch today status');
  return data;
}
